module.exports = __webpack_public_path__ + "static/media/quiz-hint-3-en.cd12aa82.vtt";